'use client'

import { ReactNode } from 'react'
import { useIntegrationActivation } from '@/features/gdpr/integration-activation-context'
import { usePurposeConsent } from '@/features/gdpr/use-purpose-consent'

interface IConsentGateProps {
    integrationId: string
    purposeId: number
    placeholder: (activate: () => void) => ReactNode
    children: ReactNode
}

export const ConsentGate = ({
    integrationId,
    purposeId,
    placeholder,
    children,
}: IConsentGateProps) => {
    const consent = usePurposeConsent(purposeId)
    const { isActivated, activate } = useIntegrationActivation(integrationId)

    if (consent === true || isActivated) return <>{children}</>

    return <>{placeholder(activate)}</>
}
